module.exports = __webpack_public_path__ + "media/Icons/placeholder_PDF-228bc8b9.svg";